const BASE = ['finCEN-SAR'] as const;

export const FINCEN_SAR_KEYS = {
  getFinCENSAR: (id: number, useCacheEndpoint: boolean) =>
    [...BASE, 'sar', id, useCacheEndpoint] as const,
};
